import { useCallback, useState } from "react"

import Modal from "@p-ban/common/src/components/lib/Modal"

import estimateField from "../../../../service/estimateFields/estimateField"
import type { SetFieldValue } from "../../../../types"
import type EstimateValues from "../../../../types/params"
import type { EstimateParams } from "../../../../types/params"
import MODAL_ID from "../../../constant/modalId"
import { useModal } from "../useModal"
import ModalContent from "./ModalContent"

type Props = {
  params: EstimateParams
  setFieldValue: SetFieldValue
}

const useModalProps = (values: EstimateValues, setFieldValue: SetFieldValue) => {
  const [count, setCount] = useState(values.cnt)
  const [repeatManufactureCount, setRepeatManufactureCount] = useState<number | null>(null)
  const { isOpen, close: _close } = useModal(MODAL_ID.MASS_PRODUCTION_SIMULATION)

  const onAfterOpen = useCallback(() => {
    setCount(values.cnt)
    setRepeatManufactureCount(repeatManufactureCount ?? values.cnt)
  }, [repeatManufactureCount, values.cnt])

  const close = useCallback(() => {
    setFieldValue(estimateField.cnt.key, count)
    _close()
  }, [_close, count, setFieldValue])

  return {
    isOpen,
    close,
    onAfterOpen,
    count,
    setCount,
    repeatManufactureCount,
    setRepeatManufactureCount,
  }
}

const MassProductionSimulation = ({ params, setFieldValue }: Props) => {
  const { isOpen, close, onAfterOpen, count, setCount, repeatManufactureCount, setRepeatManufactureCount } =
    useModalProps(params.values, setFieldValue)

  return (
    <Modal contentLabel="量産シミュレーション" isOpen={isOpen} onRequestClose={close} onAfterOpen={onAfterOpen}>
      <ModalContent
        params={params}
        count={count}
        setCount={setCount}
        repeatManufactureCount={repeatManufactureCount}
        setRepeatManufactureCount={setRepeatManufactureCount}
        close={close}
      />
    </Modal>
  )
}

export default MassProductionSimulation
